import { types as t } from 'mobx-state-tree';
import { KeyValueModel, KeyValueModelSnapshotIn } from '../../key-value.store';
import { AbstractQuestionWithMultipleOption } from '../abstract-question-multiple-option.store';

export const defaultOptions: KeyValueModelSnapshotIn[] = [
  {
    key: 0,
    value: 'True',
  },
  {
    key: 1,
    value: 'False',
  },
  {
    key: 2,
    value: 'Not Given',
  },
];

export const TFNAnswerQuestion = AbstractQuestionWithMultipleOption.named(
  'TFNAnswerQuestion'
).props({
  options: t.optional(t.array(KeyValueModel), defaultOptions),
});
